var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "checkout-step-cart col-xs-12 ph0-ns",
      class: { opened: _vm.open }
    },
    [
      _vm.empty === true && _vm.loading === false
        ? _c("div", { class: { empty: _vm.empty === true } }, [
            _vm._v(_vm._s(_vm.strings["empty_cart"]))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.empty === false && _vm.loading === false
        ? _c("div", [
            _c("div", { staticClass: "cart-items-list row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12" },
                _vm._l(_vm.cart.items, function(product, key) {
                  return _c("cart-item", {
                    key: key,
                    attrs: {
                      product: product,
                      currency: _vm.cart.currency,
                      strings: _vm.strings,
                      recap: false
                    },
                    on: {
                      add: function($event) {
                        return _vm.$emit("update-item", key, "add")
                      },
                      remove: function($event) {
                        return _vm.$emit("update-item", key, "remove")
                      },
                      delete: function($event) {
                        return _vm.$emit("delete-item", key)
                      }
                    }
                  })
                }),
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cart-totals-subtotal row" }, [
              _c("div", { staticClass: "col-sm-7" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-5" }, [
                _c("div", { staticClass: "row tnumbers" }, [
                  _c("div", { staticClass: "col-xs-6" }, [
                    _vm._v(_vm._s(_vm.strings["subtotal"]))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-6  text-right" }, [
                    _vm._v(
                      _vm._s(_vm.cart.currency) +
                        " " +
                        _vm._s(_vm.cart.subtotal.toFixed(2))
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.cart.subtotalPromo > 0
              ? _c("div", { staticClass: "cart-totals-subtotal row" }, [
                  _c("div", { staticClass: "col-sm-7" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-5" }, [
                    _c("div", { staticClass: "row tnumbers" }, [
                      _c("div", { staticClass: "col-xs-6" }, [
                        _vm._v(_vm._s(_vm.strings["promo_discount_label"]))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-6 text-right" }, [
                        _vm._v(
                          _vm._s(_vm.cart.currency) +
                            " - " +
                            _vm._s(_vm.cart.subtotalPromo.toFixed(2))
                        )
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "cart-totals-shipping-cost row" }, [
              _c("div", { staticClass: "col-sm-7" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-5" }, [
                _c("div", { staticClass: "row tnumbers" }, [
                  _c("div", { staticClass: "col-xs-6" }, [
                    _vm._v(_vm._s(_vm.strings["shipping_cost"])),
                    _c("div", { staticClass: "change-country" }, [
                      _vm._v("(" + _vm._s(_vm.cart.country.name) + ")")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-6  text-right" }, [
                    _vm.cart.shippingCostPromo != null
                      ? _c("div", { staticClass: "shipping-promo" }, [
                          _vm._v(
                            _vm._s(_vm.cart.currency) +
                              " " +
                              _vm._s(_vm.cart.shippingCostPromo.toFixed(2))
                          )
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.cart.currency) +
                        " " +
                        _vm._s(_vm.cart.shippingCost.toFixed(2)) +
                        "\n                    "
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cart-divider mv3 pa0" }),
            _vm._v(" "),
            _c("div", { staticClass: "cart-totals-total row" }, [
              _c("div", { staticClass: "col-sm-9 col-xs-12" }, [
                _c("div", { staticClass: "cart-totals-promo" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "promo-input flex flex-column flex-row-ns items-center"
                    },
                    [
                      _vm.cart.promoCheck
                        ? _c("div", [
                            _c("span", { staticClass: "mb2 mb0-ns" }, [
                              _vm._v(
                                _vm._s(_vm.strings["coupon"]) +
                                  " " +
                                  _vm._s(_vm.cart.promoCode) +
                                  "   "
                              )
                            ]),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "cart-totals-promo-remove bttn ttu mb3 mb0-ns",
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("delete-promo")
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "far fa-times" }),
                                _vm._v(
                                  "  " +
                                    _vm._s(_vm.strings["remove_coupon"]) +
                                    " "
                                )
                              ]
                            )
                          ])
                        : _c("div", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.strings["promo_label"]))
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "mh2 mt3 mt0-ns",
                              attrs: { type: "text", id: "promoCode" },
                              domProps: { value: _vm.cart.promoCode },
                              on: {
                                input: function($event) {
                                  _vm.cart.promoCode = $event.target.value.toUpperCase()
                                }
                              }
                            }),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "cart-totals-promo-submit bttn ttu mb3 mb0-ns",
                                on: {
                                  click: function($event) {
                                    return _vm.$emit(
                                      "add-promo",
                                      _vm.cart.promoCode
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(_vm._s(_vm.strings["update"]) + " "),
                                _c("i", {
                                  staticClass: "far fa-spinner-third fa-spin"
                                })
                              ]
                            )
                          ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0)
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3 col-xs-12 tnumbers text-right" },
                [
                  _c("span", { staticClass: "pt2 pr3" }, [
                    _vm._v(_vm._s(_vm.strings["total"]))
                  ]),
                  _c("span", { staticClass: "pt2" }, [
                    _vm._v(
                      _vm._s(_vm.cart.currency) +
                        " " +
                        _vm._s(_vm.cart.total.toFixed(2))
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _vm.shippingrussian === true
              ? _c("div", { staticClass: "row tr" }, [
                  _c("div", { staticClass: "col-xs-12 tc mb5 mt3" }, [
                    _c("div", {
                      staticClass: "pa3",
                      staticStyle: { "background-color": "white" },
                      domProps: {
                        innerHTML: _vm._s(_vm.strings["shipping_russian"])
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.cart.scalapay === true
              ? _c("div", { staticClass: "row tr" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12" },
                    [
                      _c("scalapay-widget", {
                        attrs: {
                          amount: _vm.cart.total.toFixed(2),
                          min: "35",
                          alignment: "right",
                          locale: _vm.lang,
                          "number-of-installments": "4"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.activebuy == false
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12 tc mb5 mt3" }, [
                    _c(
                      "div",
                      {
                        staticClass: "pa3",
                        staticStyle: { "background-color": "white" }
                      },
                      [
                        _c("h3", [
                          _c("b", [
                            _vm._v(_vm._s(_vm.strings["minimum_order_gb"]))
                          ])
                        ])
                      ]
                    )
                  ])
                ])
              : _c("div", { staticClass: "cart-totals-actions row" }, [
                  _vm.forbiddenproducts == true
                    ? _c("div", [
                        _c("div", { staticClass: "tnumbers" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  padding: "5px",
                                  background: "#303030",
                                  color: "white",
                                  "text-align": "center"
                                }
                              },
                              [_vm._v(_vm._s(_vm.strings["forbidden_order"]))]
                            )
                          ])
                        ])
                      ])
                    : _c("div", [
                        _c("div", { staticClass: "tnumbers col-xs-12 mt3" }, [
                          _c(
                            "a",
                            {
                              staticClass: "bttn tc w-100 ttu",
                              attrs: { href: _vm.api["summary"] }
                            },
                            [_vm._v(_vm._s(_vm.strings["go_to_checkout"]))]
                          )
                        ])
                      ])
                ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading === true
        ? _c("div", { staticClass: "text-center" }, [
            _c("div", { staticClass: "loader" }, [_vm._v("Loading...")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cart-items-loading",
          class: { opened: _vm.loadingpage === true }
        },
        [_vm._m(1)]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cart-totals-promo-error" }, [
      _c("i", { staticClass: "fa fa-exclamation-triangle" }),
      _vm._v(" "),
      _c("span", { staticClass: "cart-totals-promo-error-msg" }, [
        _vm._v("Errore Promozione")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex justify-center content-center items-center" },
      [_c("div", [_c("b", [_vm._v("Updating...")])])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }